'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Sample(name, component, debug, source) {
  this.fC = null;
  this.iR = null;
  this.iS = null;
  this.iT = null;
  this.fC = name;
  this.iR = component;
  this.iS = debug;
  this.iT = source;
}
export { $c_Lsamples_Sample as $c_Lsamples_Sample };
$p = $c_Lsamples_Sample.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Sample;
/** @constructor */
function $h_Lsamples_Sample() {
}
export { $h_Lsamples_Sample as $h_Lsamples_Sample };
$h_Lsamples_Sample.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().av(this, (-56166675), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_Sample)) {
    if ((this.fC === x$0.fC)) {
      var x = this.iR;
      var x$2 = x$0.iR;
      var $x_2 = ((x === null) ? (x$2 === null) : (x === x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.iS;
      var x$4 = x$0.iS;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.iT === x$0.iT);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "Sample";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.fC;
      break;
    }
    case 1: {
      return this.iR;
      break;
    }
    case 2: {
      return this.iS;
      break;
    }
    case 3: {
      return this.iT;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_Sample(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.en)));
}
export { $isArrayOf_Lsamples_Sample as $isArrayOf_Lsamples_Sample };
var $d_Lsamples_Sample = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Sample, "samples.Sample", ({
  en: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_Sample as $d_Lsamples_Sample };
